module.exports = __webpack_public_path__ + "img/special6.dc896a70.png";